import React from 'react';
import { motion } from 'framer-motion';

const faqs = [
  {
    q: "How do these professional websites help me rank locally?",
    a: "Our authority pages and professional websites are built with a 'Local SEO First' architecture. We implement schema markup specifically for Australian businesses, optimizing for location-based intent (e.g., 'accountant Parramatta' or 'NDIS Logan').\n\nThis ensures you appear when high-intent prospects search for your expertise in their immediate area, whether you are in Sydney, Melbourne, or regional Australia."
  },
  {
    q: "Is this suitable for businesses outside of professional services?",
    a: "Absolutely. While we excel in high-trust professions, our framework is designed for any local business where authority and credibility drive the decision-making process. This includes health clinics, education providers, and premium lifestyle services like barber shops and beauty studios."
  },
  {
    q: "How is an authority page different from a normal website?",
    a: "A normal website is a brochure; an authority page is a conversion engine. We focus on the psychology of decision-making. We don't just show 'what you do'—we establish 'why you are the obvious choice' before a client even calls."
  },
  {
    q: "Can I use my existing domain name?",
    a: "Yes. We can deploy the authority framework to your current domain or a new one. We handle all DNS and technical setup to ensure a seamless transition without downtime for your Sydney or interstate business."
  },
  {
    q: "Does this include hosting and security?",
    a: "Yes. Our premium service includes ultra-fast edge hosting, SSL security certificates, and daily maintenance managed from our Sydney HQ. Your page is managed by us, so you never have to worry about technical updates."
  },
  {
    q: "How long does the build take?",
    a: "The standard build time is 10-14 business days. We prioritize strategic copywriting and local SEO architecture to ensure your professional website is perfect from day one."
  },
  {
    q: "Do you handle the copywriting?",
    a: "Yes. We handle the heavy lifting of the copywriting using an 'Authority-First' framework to position you as the expert in your specific market."
  }
];

const FAQ = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.a
      }
    }))
  };

  return (
    <div className="max-w-4xl mx-auto">
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
      <h2 className="text-4xl font-bold text-white font-display mb-16 text-center">Expert Analysis & FAQs</h2>
      <div className="space-y-6">
        {faqs.map((faq, idx) => (
          <motion.div 
            key={idx} 
            initial={{ opacity: 0, y: 10 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            transition={{ delay: idx * 0.05 }} 
            className="glass-card p-8 md:p-12"
          >
            <h3 className="text-xl font-bold text-white mb-6 font-display leading-tight">{faq.q}</h3>
            <div className="text-slate-400 text-sm leading-relaxed space-y-4">
              {faq.a.split('\n\n').map((p, i) => <p key={i}>{p}</p>)}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;